



















































































































































import { SfButton, SfSidebar, SfImage } from '~/components/StorefrontUi';
import ImageWrapper from '~/components/image/ImageWrapper.vue';
import {
  defineComponent,
  useRouter,
  useContext,
  computed, ref, useFetch, watch,
} from '@nuxtjs/composition-api';
import { useUiHelpers, useUiState, useImage } from '~/composables';
import { useTraverseCategory } from '~/modules/catalog/category/helpers/useTraverseCategory';
import { CategoryTree } from '~/modules/GraphQL/types';
import { addBasePath } from '~/helpers/addBasePath';
import { getCategoryImage } from '~/helpers/getCategoryImage';
import { findActiveCategory } from '~/modules/catalog/category/helpers/findActiveCategory';
import useStoryblokView from '~/modules/storyblok/composables/useStoryblokView';
import LangSelect from '~/components/MainHeader/LangSelect/LangSelect.vue';
import { useMobileCategoryTree } from './logic';

export default defineComponent({
  name: 'MobileCategorySidebar',
  components: {
    SfSidebar,
    SfImage,
    SfButton,
    ImageWrapper,
    LangSelect,
  },
  setup() {
    const { isMobileMenuOpen, toggleMobileMenu } = useUiState();
    const { getCatLink } = useUiHelpers();
    const router = useRouter();
    const { env, localePath, app } = useContext();
    const { getMagentoImage } = useImage();
    const lang = computed(() => app.i18n.locale);
    const { getStoryBySlug } = useStoryblokView();
    const navItems = ref([]);

    const { fetch } = useFetch(async () => {
      const { story } = await getStoryBySlug({
        slug: 'general/header',
        redirectOnError: true,
      });

      if (story) {
        navItems.value = story.content.links;
      }
    });

    fetch();

    watch(() => lang.value, () => {
      fetch();
    });

    const { categoryAncestors: initialHistory, categoryTree } = useTraverseCategory();
    const navigate = (category: CategoryTree) => {
      toggleMobileMenu();
      const path = getCatLink(category);
      router.push(localePath(path));
    };

    const navigateStatic = (path: string) => {
      toggleMobileMenu();
      if (path.startsWith('https://')) {
        window.open(path, '_blank');
      } else {
        router.push(localePath(path));
      }
    };
    // A category with no child categories can't be entered into - it can only navigated to
    const initialHistoryWithSnippedSubcategoryLessTail = initialHistory.value.at(-1)?.children?.length
      ? initialHistory.value
      : initialHistory.value.slice(0, -1);

    const {
      current: currentCategory,
      history,
      currentItems,
      onGoCategoryUp,
      onGoCategoryDown,
    } = useMobileCategoryTree(initialHistoryWithSnippedSubcategoryLessTail);

    const itemsIncludedInMenu = computed(() => {
      const mainCategoryUid = env.VSF_MAGENTO_MAIN_CATEGORY_UID;
      const activeCategory = categoryTree.value === null
        ? null
        : findActiveCategory(
          categoryTree.value,
          mainCategoryUid as string,
          'uid',
        );
      const maybeCurrentCategoryItems = currentItems.value || activeCategory.children;
      return maybeCurrentCategoryItems?.filter((item) => item.include_in_menu);
    });

    return {
      addBasePath,
      getCategoryImage,
      currentCategory,
      onGoCategoryUp,
      onGoCategoryDown,
      history,
      navigate,
      navigateStatic,
      isMobileMenuOpen,
      toggleMobileMenu,
      itemsIncludedInMenu,
      navItems,
      getMagentoImage,
    };
  },
});
